"use client";

import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type GetSituationsRequest, type Situation } from "@/generated/fastapi";
import { getSituations } from "../api/getSituations";
import { situationsKeys } from "./keys";

type UseSituationsQueryOptions = {
  initialData?: Situation[];
  request?: GetSituationsRequest;
};

export default function useSituationsQuery({
  initialData,
  request = {},
}: UseSituationsQueryOptions = {}) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: [...situationsKeys.list(), request],
    queryFn: () => getSituations(accessToken, request),
    enabled: Boolean(accessToken),
    initialData,
  });
}
